import { colors } from '../../colors';
var pencilBanner = {
  bgColor: colors.duskBlue,
  textColor: colors.graphite,
  textColorDark: colors.graphite,
  textColorLight: colors.white
};
export default pencilBanner;